import axios from "axios";
import { useApi } from "../hooks/useApi"
import { IProfileTraveler } from "../interfaces/userInfo";

const api = useApi();

export async function getProfilResident(trocPairId: string) {
  try {
    const response = await api.post(`getting/profil/resident/troc_request_id/${trocPairId}`);
    return response;

  } catch (error) {
    throw error;
  }
}

export async function getProfilTrav() {
  try {
    const response = await api.get("users/profil");
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function modifProfilTrav(values: IProfileTraveler) {
  try {
    const response = await api.put("users/update-profil", values);
    return (response.status === 200) && response.status;
  } catch (error) {
    return error;
  }
}

export async function getTravPublicProfil(travPseudo: string): Promise<{ pseudo: string; presentation: string; number_troc_done: number; last3Comments: { content: string }[] | null, badges: string[] }> {
  try {
    const { data } = await api.get(`users/trav-public-profil${travPseudo}`);
    return data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        switch (error.response?.status) {
          case 400:
            throw new Error(`${error.response.data.message}`);
          case 404:
            throw new Error(`${error.response.data.message}`);
          case 500:
            throw new Error(`Une erreur est suvenue. Rééssayez plus tard.`);
          default:
            throw new Error(`Une erreur est survenue.`);
        }
      }
      else if (error.request) {
        throw new Error(`Une erreur est survenue.`);
      }
      else if (axios.isCancel(error)) {
        throw new Error(`Une erreur est survenue.`);
      }
      else {
        // Ici on cast `error` comme un objet contenant un message
        throw new Error(`Une erreur est survenue.`);
      }
    } else {
      // Gère les erreurs non Axios (par exemple, erreur JavaScript générique)
      throw new Error(`Une erreur est survenue.`);
    }
  }
}